module.exports = __webpack_public_path__ + "./images/RCSmalasPracticas.a9c3131a88c57afac60dce68601eb32f.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/RCSmalasPracticas.png
// module id = ./websources/public/images/RCSmalasPracticas.png
// module chunks = 0